import React, { useState, useEffect, useRef } from 'react'; // ✅ All in one
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useNavigate } from 'react-router-dom';
import './Home.css';
import CountUp from 'react-countup';
import { Link } from 'react-router-dom'
import Sliders from './Sliders';
import Tstimonialshow from "../AdminTestimonialpanel/Tstimonialshow";
import Bloghome from '../Blog/Bloghome';
import Selhome from '../Blog/Selhome';








const Home = () => {
 
  const [line1, setLine1] = useState("");
  const [line2, setLine2] = useState("");
  const [paragraph, setParagraph] = useState("");
  const [showButton, setShowButton] = useState(false);
  const [isCentered, setIsCentered] = useState(false);

  useEffect(() => {
    let timeouts = [];

    // Clear function to clean up timeouts
    const clearAllTimeouts = () => {
      timeouts.forEach(clearTimeout);
      timeouts = [];
    };

    // Reset all states
    setLine1("");
    setLine2("");
    setParagraph("");
    setShowButton(false);

    const text1 = "WELCOME TO BDM TECHNOLOGY";
    const text2 = "Your Gateway to SAP Excellence!";
    const para = "";

    const typeLine1 = (index = 0) => {
      if (index < text1.length) {
        setLine1(text1.substring(0, index + 1));
        const timeout = setTimeout(() => typeLine1(index + 1), 70);
        timeouts.push(timeout);
      } else {
        const timeout = setTimeout(() => typeLine2(), 300);
        timeouts.push(timeout);
      }
    };

    const typeLine2 = (index = 0) => {
      if (index < text2.length) {
        setLine2(text2.substring(0, index + 1));
        const timeout = setTimeout(() => typeLine2(index + 1), 60);
        timeouts.push(timeout);
      } else {
        const timeout = setTimeout(() => { setIsCentered(true); setShowButton(true) }, 100);
        timeouts.push(timeout);
      }
    };


    // Start the typing sequence
    typeLine1();

    // Cleanup function
    return () => {
      clearAllTimeouts();
    };
  }, []);




 


  // Custom Navigation Components
  const NextArrow = ({ onClick }) => (
    <div className="testimonial-nav testimonial-nav-next" onClick={onClick}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M9 18l6-6-6-6" />
      </svg>
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div className="testimonial-nav testimonial-nav-prev" onClick={onClick}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </div>
  );

  // Star Rating Component
  const StarRating = ({ rating }) => (
    <div className="star-rating">
      {[...Array(5)].map((_, i) => (
        <svg
          key={i}
          className={`star ${i < rating ? '' : 'empty'}`}
          viewBox="0 0 24 24"
          fill={i < rating ? "currentColor" : "none"}
          stroke="currentColor"
          strokeWidth="2"
        >
          <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
        </svg>
      ))}
    </div>
  );

  // Slider Settings

  const navigate = useNavigate();

  const courses = [
    {
      id: 1,
      image: "/assets/img/courses-1.jpg",
      title: "SAP Finance and Controlling (FICO)",
      desc: "Master financial management and cost control.",
      link: "/sapfin"
    },
    {
      id: 2,
      image: "/assets/img/courses-2.jpg",
      title: "SAP Material Management(MM)",
      desc: "Learn procurement and inventory management.",
      link: "/sapmm"
    },
    {
      id: 3,
      image: "/assets/img/courses-3.jpg",
      title: "SAP HR Management(HCM)",
      desc: "Gain expertise in human capital management.",
      link: "/saphcm"
    },
    {
      id: 4,
      image: "/assets/img/courses-4.jpg",
      title: "SAP Plant Maintenance (PM)",
      desc: "Understand equipment maintenance and lifecycle.",
      link: "/sappm"
    },
    {
      id: 5,
      image: "/assets/img/courses-5.jpg",
      title: "SAP Project Systems(PS)",
      desc: "Manage large-scale projects efficiently.",
      link: "/sapps"
    },
    {
      id: 6,
      image: "/assets/img/courses-6.jpg",
      title: "SAP Production Planning(PP)",
      desc: "Optimize manufacturing processes.",
      link: "/sappp"
    },
    {
      id: 7,
      image: "/assets/img/courses-6.jpg",
      title: "SAP Sales and Distribution(SD)",
      desc: "Improve sales, billing, and logistics.",
      link: "/sapsd"
    },
    {
      id: 8,
      image: "/assets/img/courses-5.jpg",
      title: "SAP ABAP",
      desc: "Learn SAP's programming for system customization.",
      link: "/sapab"
    }
  ];

  useEffect(() => {
    // Create animated background particles
    const createParticle = () => {
      const particles = document.querySelector('.particles');
      const particle = document.createElement('div');
      particle.className = 'particle';
      particle.style.left = Math.random() * 100 + 'vw';
      particle.style.animationDuration = Math.random() * 3 + 2 + 's';
      particles.appendChild(particle);

      setTimeout(() => {
        particle.remove();
      }, 5000);
    };

    // Create particles at intervals
    const particleInterval = setInterval(createParticle, 300);

    return () => clearInterval(particleInterval);
  }, []);

  const styles = {
  section: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "stretch",
    gap: "20px",
    padding: "20px",
    background: "#f4f4f4",
    flexWrap: "wrap",
  },
  eventBox: {
    flex: "1 1 30%",
    background: "#fff",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 0 12px rgba(0, 0, 0, 0.1)",
  },
  eventTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  eventItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
  },
  eventDate: {
    backgroundColor: "#ff0046",
    color: "#fff",
    padding: "10px",
    borderRadius: "8px",
    marginRight: "10px",
    textAlign: "center",
    minWidth: "50px",
  },
  eventMonth: {
    fontSize: "12px",
    fontWeight: "bold",
  },
  eventDay: {
    fontSize: "20px",
    fontWeight: "bold",
  },
  eventInfo: {
    color: "#333",
  },
  eventInfoItem: {
    marginBottom: "5px",
  },
  eventCenter: {
    flex: "1 1 30%",
    backgroundImage: "url('./images/Day-Bg.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    borderRadius: "12px",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "220px",
  },
  overlayText: {
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    padding: "25px 30px",
    borderRadius: "12px",
    color: "white",
    textAlign: "center",
    animation: "fadeIn 1s ease-in-out",
  },
};



  const heading = "Welcome to BDM";
  const quotes = [
    "🎯 Focus on SAP S/4HANA innovations.",
    "🚀 Drive digital transformation with BDM strategies.",
    "📊 Analyze your data. Build smarter enterprises.",
    "🌐 Connect SAP modules for business excellence.",
    "📈 Automate workflows. Improve efficiency.",
    "🛠️ Train your team for future-ready ERP."
  ];

  const [typedHeading, setTypedHeading] = useState('');
  const [headingIndex, setHeadingIndex] = useState(0);

  const [quoteIndex, setQuoteIndex] = useState(0);
  const [typedQuote, setTypedQuote] = useState('');
  const [quoteCharIndex, setQuoteCharIndex] = useState(0);

  // Typing heading
  useEffect(() => {
    if (headingIndex < heading.length) {
      const timeout = setTimeout(() => {
        setTypedHeading(prev => prev + heading[headingIndex]);
        setHeadingIndex(prev => prev + 1);
      }, 120);
      return () => clearTimeout(timeout);
    }
  }, [headingIndex, heading]);

  // Typing quote one character at a time
  useEffect(() => {
    if (quoteCharIndex < quotes[quoteIndex].length) {
      const timeout = setTimeout(() => {
        setTypedQuote(prev => prev + quotes[quoteIndex][quoteCharIndex]);
        setQuoteCharIndex(prev => prev + 1);
      }, 80);
      return () => clearTimeout(timeout);
    } else {
      // Wait before switching to the next quote
      const delay = setTimeout(() => {
        const nextIndex = (quoteIndex + 1) % quotes.length;
        setQuoteIndex(nextIndex);
        setTypedQuote('');
        setQuoteCharIndex(0);
      }, 4000); // 4 seconds before next quote
      return () => clearTimeout(delay);
    }
  }, [quoteCharIndex, quotes, quoteIndex]);


  const imageRef = useRef(null);

useEffect(() => {
  const imageEl = imageRef.current;

  const handleMouseMove = (e) => {
    const { left, top, width, height } = imageEl.getBoundingClientRect();
    const x = e.clientX - left;
    const y = e.clientY - top;

    const rotateX = ((y / height) - 0.5) * 70;
    const rotateY = ((x / width) - 0.5) * 70;

    imageEl.style.animation = "none"; // Pause zoom animation
    imageEl.style.transform = `scale(1.08) rotateX(${-rotateX}deg) rotateY(${rotateY}deg)`;
  };

  const handleMouseLeave = () => {
    imageEl.style.transform = `scale(1.03) rotateX(0deg) rotateY(0deg)`;
    imageEl.style.animation = "slowZoom 10s ease-in-out infinite"; // Resume zoom animation
  };

  imageEl.addEventListener("mousemove", handleMouseMove);
  imageEl.addEventListener("mouseleave", handleMouseLeave);

  return () => {
    imageEl.removeEventListener("mousemove", handleMouseMove);
    imageEl.removeEventListener("mouseleave", handleMouseLeave);
  };
}, []);


  

  return (
    <div>
      <div className="sapfincon-wrapper">
  <div className="background-animation">
    <div className="floating-circle"></div>
    <div className="floating-circle"></div>
    <div className="floating-circle"></div>
    <div className="floating-circle"></div>
    <div className="floating-circle"></div>
    <div className="floating-circle"></div>
  </div>

<div>
      <Sliders /> {/* This will show only on the Home page, below Header */}
      {/* Other Home content goes here */}
    </div>


   
    












      {/* About Start */}
      <div className="container-fluid py-5"
        style={{
         
          width: "100vw",
          marginLeft: "calc(-50vw + 50%)",
          paddingLeft: "5vw",
          paddingRight: "5vw",
        }}
      >
        <div className="row gx-0">
          <div className="col-lg-5 mb-5 mb-lg-0" style={{ minHeight: "500px" }}>
  <div className="position-relative h-100" ref={imageRef} style={{ perspective: "1000px" }}>
   <img
  className="w-100 h-100 img-fluid"
  src="/assets/img/powerpressmachine.jpg"
  style={{
    objectFit: "cover", // better for responsive image
    transition: "transform 0.1s ease-out",
    transformStyle: "preserve-3d",
  }}
  alt="About"
/>

  </div>
</div>
<div className="col-lg-7 px-5">
  <div className="section-title position-relative mb-4">
    <h6 className="d-inline-block position-relative text-secondary text-uppercase pb-2">About Us</h6>
    <h1 className="display-4">Welcome to RAMESH ENTERPRISES</h1>
  </div>

  <p>
    Ramesh Enterprises brings decades of expertise in welding solutions, tool manufacturing, and hydraulic press components, 
    serving diverse engineering industries with reliable and high-performance products.
  </p>

  <p><strong>We specialize in:</strong></p>
  <ul className="fs-5 text-justify mb-4 ps-4">
    <li> Hydraulic Press Components & Assemblies</li>
    <li> Tool & Die Manufacturing</li>
    <li> TIG / CO₂ Welding Solutions</li>
    <li> Fabrication & Heavy Welding Jobs</li>
    <li> Precision Machining Support for Press & Welding Applications</li>
  </ul>

  <p>
    With a strong focus on quality, durability, and innovation, Ramesh Enterprises has built long-standing partnerships with 
    leading OEMs and engineering companies. Our solutions ensure strength, reliability, and productivity for critical industrial applications.
  </p>

  <h5 className="fw-bold text-orange mb-3">Our Strengths</h5>
  <ul className="fs-5 text-justify mb-4 ps-4">
    <li> Complete In-House Tooling, Welding & Press Component Manufacturing</li>
    <li> Robust Hydraulic Press & Welding Infrastructure</li>
    <li> Commitment to On-Time Delivery & Quality Assurance</li>
    <li> ISO Certified Quality & Skilled Workforce</li>
  </ul>
</div>

        </div>
      </div>


      {/* About End */}

<div className="container py-5">
  <div className="text-center mb-5">
    <h2 className="mission-heading">
      Our Mission, Vision & Values
    </h2>
  </div>

  <div className="px-md-5">
    {/* Vision */}
    <h5 className="fw-bold text-orange mb-3">🌐 Our Vision</h5>
    <p className="fs-5 text-justify mb-4">
      To be a one-stop manufacturing solutions provider, delivering welding, tool press, and hydraulic press products to engineering industries.
    </p>

    {/* Mission */}
    <h5 className="fw-bold text-orange mb-3">🎯 Our Mission</h5>
    <ul className="fs-5 text-justify mb-4 ps-4">
      <li> Embrace advanced technologies to manufacture welding, tool press, and hydraulic press components and assemblies.</li>
      <li> Implement robust systems and processes to ensure quality products, on-time delivery, and competitive pricing.</li>
      <li> Foster an engaged and motivated workforce aligned with organizational goals and values.</li>
    </ul>

    {/* Governing Values */}
    <h5 className="fw-bold text-orange mb-3">💡 Our Governing Values</h5>
    
    <p className="fs-5 fw-bold mb-2">Customer First</p>
    <ul className="fs-5 text-justify mb-4 ps-4">
      <li> Give top priority to customer communication in all forms.</li>
      <li> Listen first, respond later—understanding customer needs before acting.</li>
      <li> Commit to complete customer satisfaction without compromise.</li>
    </ul>

    <p className="fs-5 fw-bold mb-2">Ownership</p>
    <ul className="fs-5 text-justify mb-4 ps-4">
      <li>Use resources—people, money, materials, and machines—efficiently, with zero wastage.</li>
      <li> Take responsibility for learning, duties, and deliverables without reminders.</li>
      <li> Consistently comply with workplace discipline and standards.</li>
    </ul>

    <p className="fs-5 fw-bold mb-2">Continual Improvement</p>
    <ul className="fs-5 text-justify mb-4 ps-4">
      <li> Contribute at least one Kaizen (improvement idea) per month and implement it.</li>
      <li> Create and achieve an annual learning plan for personal and professional growth.</li>
    </ul>
  </div>
</div>


      {/* Feature Start */}
     <div className="container-fluid py-5">
  <div className="container">
    <div className="text-center mb-5">
      <h2 className="display-5 mb-4" style={{ color: 'orangered', fontWeight: '700' }}>
        Why Choose Ramesh Enterprises
      </h2>
      <p className="lead" style={{ color: 'black' }}>
        Your trusted manufacturing partner for over three decades
      </p>
    </div>

    <div className="row g-4">
      <div className="col-lg-3 col-md-6">
        <div className="text-center h-100 p-4">
          <div
            className="bg-primary rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
            style={{ width: '80px', height: '80px' }}
          >
            <i className="fas fa-industry text-white" style={{ fontSize: '1.8rem' }}></i>
          </div>
          <h5 className="mb-3" style={{ color: '#2c5aa0' }}>35+ Years Legacy</h5>
          <p className="text-muted">We are more than 35 year old organization delivering precision manufacturing solutions.</p>
        </div>
      </div>

      <div className="col-lg-3 col-md-6">
        <div className="text-center h-100 p-4">
          <div
            className="bg-success rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
            style={{ width: '80px', height: '80px' }}
          >
            <i className="fas fa-cogs text-white" style={{ fontSize: '1.8rem' }}></i>
          </div>
          <h5 className="mb-3" style={{ color: '#2c5aa0' }}>Comprehensive Capabilities</h5>
          <p className="text-muted">
            Facilities for designing, manufacturing & supply of Press Components, Welded Fabrication, Machined & Turned Components, Press Tools, Welding Fixtures, Jigs & Fixtures.
          </p>
        </div>
      </div>

      <div className="col-lg-3 col-md-6">
        <div className="text-center h-100 p-4">
          <div
            className="bg-warning rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
            style={{ width: '80px', height: '80px' }}
          >
            <i className="fas fa-drafting-compass text-white" style={{ fontSize: '1.8rem' }}></i>
          </div>
          <h5 className="mb-3" style={{ color: '#2c5aa0' }}>Engineering & Tooling</h5>
          <p className="text-muted">
            In-house Engineering & Design facility with advanced Tool Room machines for Pressed Components, Welded Assemblies, and Tubular Pipe Bending.
          </p>
        </div>
      </div>

      <div className="col-lg-3 col-md-6">
        <div className="text-center h-100 p-4">
          <div
            className="bg-info rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
            style={{ width: '80px', height: '80px' }}
          >
            <i className="fas fa-tools text-white" style={{ fontSize: '1.8rem' }}></i>
          </div>
          <h5 className="mb-3" style={{ color: '#2c5aa0' }}>Advanced Manufacturing</h5>
          <p className="text-muted">
            Expertise in CO₂ & Robotic Welding, TIG & Spot Welding, Hydraulic Deep Draw, Machining & Turning processes with focus on precision and quality.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>


      {/* Feature Start */}

      {/* Courses Start */}
      {/* <div className="container-fluid py-5" style={{ marginTop: "-90px", padding: "0 10px" }}>
        <div className="container-fluid py-5" style={{ padding: "0 10px" }}>
          <div className="row justify-content-center mx-0 mt-4">
            <div className="col-lg-8">
              <div className="section-title text-center position-relative mb-5">
                <h6 className="d-inline-block position-relative text-secondary text-uppercase pb-2 fade-in fade-delay-1">
                  Our Courses
                </h6>
                <h1 className="display-4 fade-in fade-delay-2">
                  Checkout New Releases Of Our Courses
                </h1>
              </div>

            </div>
          </div>

         {Array.from({ length: Math.ceil(courses.length / 3) }).map((_, rowIndex) => (
<div className="row gx-1 mx-auto" style={{ maxWidth: '1140px' }} key={rowIndex}>

  {courses
    .slice(rowIndex * 3, rowIndex * 3 + 3)
    .map((course) => (
      <div className="col-lg-4 col-md-6 pb-4" key={course.id}>
        <div
          className="card h-100 shadow-sm"
          style={{
            cursor: 'pointer',
            borderRadius: '10px',
            border: '1px solid gray',
            boxShadow: ' 4px 8px rgba(0, 0, 0, 1)',
            padding: '5px',
            backgroundColor: '#fff',
            width: '95%',
            margin: '0 auto'
          }}
          onClick={() => navigate(course.link)}
        >
          <img
  src={course.image}
  className="card-img-top zoom-anim"
  alt={course.title}
  style={{
    height: "200px",
    objectFit: "cover",
    borderRadius: "8px",
    width: "100%"
  }}
/>

          <div className="card-body px-0 pt-3">
            <span className="badge bg-primary mb-2">{course.category}</span>
            <h5 className="card-title  text-dark">{course.title}</h5>
            <p className="card-text">{course.desc}</p>
          </div>
        </div>
      </div>
    ))}
</div>


))}
        </div>
      </div> */}


      {/* Courses End */}

     <div>
    <Bloghome />
    </div>
<div>
    <Selhome />
    </div>

    


    <div>
      <Tstimonialshow />
    </div>
      
    

     

      {/* JavaScript Libraries */}
      <script src="https://code.jquery.com/jquery-3.4.1.min.js"></script>
      <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.bundle.min.js"></script>
      <script src="lib/easing/easing.min.js"></script>
      <script src="lib/waypoints/waypoints.min.js"></script>
      <script src="lib/counterup/counterup.min.js"></script>
      <script src="lib/owlcarousel/owl.carousel.min.js"></script>

      {/* Template Javascript */}
      <script src="js/main.js"></script>

     

    </div>
    </div>
  );
};

export default Home;